import React from 'react';
import CourseComponent from 'Components/Card/Components/CourseComponent';
import withSMARTGoalOnUpdateCardComponent from 'Components/Card/hoc/withSMARTGoalOnUpdateCardComponent';

function LMSCourseCard(props) {
    const { Course: course } = props.data;

    return (
        <CourseComponent course={course} />
    )
}

export default withSMARTGoalOnUpdateCardComponent(LMSCourseCard);